import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsComponentsRoute: InvariantJiraRoute = {
	name: 'project-settings-components',
	path: '/plugins/servlet/project-config/:projectKey/administer-components',
};
